<app-loader [isLoading]="isLoading"></app-loader>
<div *ngIf="!isLoading">
  <div class="orders-container">
    <h2 class="orders-title">My Orders</h2>
    <!-- ONE CARD PER ORDER ID -->
    <div class="order-card" *ngFor="let order of groupedOrders" (click)="getOrderId(order?.order_id)">
      <!-- 🔥 Items list inside same order card -->
      <div class="status-box">
        <div class="delivered-status" [ngClass]="{
                 'status-delivered': order?.status === 'delivered',
                 'status-partially': order?.status === 'Partially_Returned',
                 'status-fully': order?.status === 'Fully_Returned',
                 'status-partially-replaced': order?.status === 'Partially_Replaced',
                 'status-fully-replaced': order?.status === 'Fully_Replaced',
                 'status-pending': order?.status === 'pending',
                 'status-cancelled': order?.status === 'cancelled',
                  'status-return': order?.status === 'Return_Requested',
                  'status-replace': order?.status === 'Replace_Requested',
                 'status-processing': order?.status === 'processing',
                 'status-shipped': order?.status === 'shipped',
                 'status-out-for-delivery': order?.status === 'out_for_delivery',
                 'status-confirmed': order?.status === 'confirmed',
                 'status-replace-ship': order?.status === 'Replacement_Shipped',
                 'status-return-approve': order?.status === 'Return_Approved',
                 'status-replace-approve': order?.status === 'Replace_Approved',
                 'status-refund-processing': order?.status === 'Refund_Processing',
                 'status-replace-picked': order?.status === 'Picked_Up'

               }">
          <span class="tick" *ngIf="order?.status === 'delivered'">✔</span>
          {{ getDisplayStatus(order) }}
        </div>
        <span class="payment-method">{{
          order?.payment_method === 'COD'
          ? 'Cash on Delivery'
          : order?.payment_method === 'ONLINE'
          ? 'Online Payment'
          : ''
          }}</span>
      </div>
      <div class="order-items">
        <div class="order-item-row" *ngFor="let item of order.items">
          <img [src]="imageBaseUrl + item?.image" class="product-img">
          <div class="order-details">
            <div class="product-title">{{item?.product | titlecase}}</div>
            <div *ngIf="item?.size" class="size">{{ getVariantLabel(item?.size) }}: {{item?.size}}</div>
          </div>
          <div class="right-info">
            <span class="date">{{order?.order_date | date:'dd MMM yyyy, hh:mm a'}}</span>
            <span class="price"> ₹{{item?.price}} Qty ({{item?.quantity}})</span>
            <span class="order-id">Order # {{order?.order_id}}</span>
          </div>
        </div>
        <div class="border-top-grand">
          <span class="total-text">Grand Total : </span>
          <span class="total-price"> ₹ {{order?.totalAmount}}</span>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="!errMessage && (noDataFound?.status === 'empty' || groupedOrders?.length === 0)" class="nodata-found">
  No Orders Available
</div>
<div class="col-12 text-center pt-1" *ngIf="errMessage">
  <div class="address-form p-3">
    <p class="mb-3">Please login to view your orders</p>
    <button mat-raised-button color="primary" (click)="goToLogin()">
      Login Now
    </button>
  </div>
</div>